<script>
  import { Input, Button, Link, Alert } from '@storytel/design-system-web';
  import { onMount, tick } from 'svelte';
  import Centered from '../styling/Centered.svelte';
  import { getSthpHost } from '../config';
  import { createEventDispatcher } from 'svelte';
  import { l10n } from '../utils/Utils';

  const dispatch = createEventDispatcher();

  export let country,
    language,
    forgotPasswordLink,
    env = 'local',
    showLoader,
    currentErrorOrigin;

  let form,
    isMounted = false,
    errorMessage = '',
    isSubmitting = false;

  onMount(async () => {
    await tick();

    isMounted = true;
  });

  async function handleSubmit() {
    dispatch('error', { component: '' });

    showLoader = true;

    isSubmitting = true;
    const url = new URL(`${getSthpHost(env)}/${country}/${language}/login.action`);
    const formData = new FormData(form);
    let response,
      result = null,
      isSuccess = false;

    if (form.email.value && form.password.value) {
      formData.append('terminal', 'Web2.0');

      try {
        response = await fetch(url, {
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify(Object.fromEntries(formData)),
        });
      } catch (error) {
        errorMessage = l10n('generic.error.message');
        showLoader = false;
        isSubmitting = false;
      }

      try {
        result = await response.json();
      } catch (error) {
        errorMessage = l10n('generic.error.message');
        console.warn('No connection to API, cannot read response:', error);
      }
      isSuccess =
        result && (result.result === 'success' || result.result === 'redirectToAccountPage');
    }

    if (isSuccess) {
      dispatch('loginSuccess', { method: 'email' });
    } else if (result && result.errorText) {
      errorMessage = result.errorText;
      dispatch('error', { component: 'EmailPassword' });
    } else {
      errorMessage = l10n('generic.error.message');
      dispatch('error', { component: 'EmailPassword' });
    }

    showLoader = false;
    isSubmitting = false;
  }

</script>

{#if isMounted}
  <form on:submit|preventDefault={handleSubmit} bind:this={form}>
    <div style="margin-bottom: 5px;">
      <Input
        type="email"
        id="email"
        name="username"
        required="true"
        hasError={errorMessage}
        placeholder={l10n('login.username')}
      />
      <Input
        type="password"
        id="password"
        name="password"
        placeholder={l10n('login.password')}
        required="true"
        hasError={errorMessage}
      />
    </div>

    {#if currentErrorOrigin === 'EmailPassword' && errorMessage}
      <Alert type="error">{errorMessage}</Alert>
    {/if}

    <Button id="login-button" type="primary" disabled={isSubmitting} fullwidth>
      {l10n('login.login')}
    </Button>

    <Centered>
      <Link href={forgotPasswordLink} noUnderline="true" orange="true">
        {l10n('login.resetPassword')}
      </Link>
    </Centered>
  </form>
{/if}
